module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/portal/portal.component.css
// module id = ./src/app/Screens/portal/portal.component.css
// module chunks = main